import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Photos from './photos';

const SliderSection = ({ id, title, data, underlineWidth = 290 }) => {

  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

useEffect(() => {
  const updateVisibleCount = () => {
    const isSmall = window.innerWidth <= 440;
    const newVisibleCount = isSmall ? 1 : 3;

    setVisibleCount(newVisibleCount);
    setIsSmallScreen(isSmall);

    // Fix: Adjust startIndex if it goes beyond new visible range
    const maxStartIndex = Math.max(0, data.length - newVisibleCount);
    setStartIndex((prevIndex) => Math.min(prevIndex, maxStartIndex));
  };

  updateVisibleCount();
  window.addEventListener('resize', updateVisibleCount);
  return () => window.removeEventListener('resize', updateVisibleCount);
}, [data.length]);


  const handleNext = () => {
    const nextIndex = startIndex + visibleCount;
    if (nextIndex < data.length) {
      setStartIndex(nextIndex);
    }
  };

  const handlePrev = () => {
    const prevIndex = startIndex - visibleCount;
    if (prevIndex >= 0) {
      setStartIndex(prevIndex);
    }
  };

  const getVisibleItems = () => data.slice(startIndex, startIndex + visibleCount);

  const visibleItems = getVisibleItems();
  const shouldShowCarousel = data.length > 1 && data.length > visibleCount;

  return (
    <div id={id} className="mt-[70px] relative w-full">
      <h2
        className={`text-center font-bold text-[#AD2F3B] 
        text-[36px] ${isSmallScreen ? '!text-[20px]' : ''}`}
      >
        {title}
      </h2>
<div
  className="h-[1px] bg-[#AD2F3B] mx-auto mt-[2px] mb-[70px] max-[440px]:mb-[20px]"
  style={{ width: isSmallScreen ? `${underlineWidth * 0.5}px` : `${underlineWidth}px` }}
/>


      <div className="relative flex justify-center items-center w-full overflow-hidden">

        {shouldShowCarousel && startIndex > 0 && (
          <button
            onClick={handlePrev}
            className={`text-gray-800 absolute left-0 ${
              isSmallScreen ? 'pl-4' : 'pl-[100px]'
            } top-1/2 -translate-y-[100%]
 z-10`}
          >
            <ChevronLeft size={40} strokeWidth={1.5} />
          </button>
        )}

        <div
          className={`flex gap-[50px] items-center ${
            isSmallScreen ? 'justify-center w-full' : 'justify-center'
          }`}
        >
          {visibleItems.map((person, index) => (
            <Photos
              key={`${title}-${startIndex + index}`}
              image={person.image}
              title={person.title}
              details={person.details}
              post={person.post}
            />
          ))}
        </div>

        {shouldShowCarousel && startIndex + visibleCount < data.length && (
          <button
            onClick={handleNext}
            className={`text-gray-800 absolute right-0 ${
              isSmallScreen ? 'pr-4' : 'pr-[100px]'
            } top-1/2 -translate-y-[100%] z-10`}
          >
            <ChevronRight size={40} strokeWidth={1.5} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SliderSection;
